export default __webpack_public_path__ + "static/media/exordium-main-poster-w990.01af25a3.webp";